import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SubscribePopup from './components/SubscribePopup';

import './styles/global.css';

// Lazy-loaded pages
const Home = lazy(() => import('./pages/Home'));
const Tutorials = lazy(() => import('./pages/Tutorials'));
const Projects = lazy(() => import('./pages/Projects'));
const ProjectDetails = lazy(() => import('./pages/ProjectDetails'));
const Ebooks = lazy(() => import('./pages/Ebooks'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Loading Component
const PageLoader = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '16px',
      background: 'var(--bg-primary)',
    }}
  >
    <div
      style={{
        width: '44px',
        height: '44px',
        border: '3px solid var(--border-color)',
        borderTopColor: 'var(--accent-primary)',
        borderRadius: '50%',
        animation: 'rotate 0.8s linear infinite',
      }}
    />

    <span
      style={{
        color: 'var(--text-muted)',
        fontSize: '0.9rem',
        fontFamily: 'var(--font-heading)',
      }}
    >
      Loading...
    </span>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <ScrollToTop />

          <Navbar />

          <main>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:id" element={<ProjectDetails />} />
                <Route path="/ebooks" element={<Ebooks />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>

          <Footer />

          {/* Subscribe Popup */}
          <SubscribePopup />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;